import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

import { APIAccounts } from "../../../../api";

import PlansTable from "./components/PlansTable";

import { customerActions } from "../../../../reducers/customer";
import { ACCOUNTS_API_URLS } from "../../../../api/accounts";
import { ContainerWithLoader, PaginationWithLimit } from "../../../../components/ui";
import usePagination from "../../../../hooks/usePagination";

const UserPlans = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { id }: { id: string } = useParams();

  const pagination = usePagination(5);

  const { loading } = useSelector((state) => state.customer.plans);

  const { isError, error } = useQuery({
    retry: false,
    queryKey: [ACCOUNTS_API_URLS.accountPlans, id, pagination.page],
    async queryFn() {
      dispatch(customerActions.fetchPlansRequest());
      const response = await APIAccounts.getCustomerPlansRequest(id, pagination.page);
      pagination.setCount(response.data.count);
      dispatch(customerActions.fetchPlansSuccess(response.data));

      return response;
    },
  });

  useEffect(() => {
    if (isError && error) {
      dispatch(customerActions.fetchPlansFailed());
    }
  }, [isError, error]);

  return (
    <div>
      <Typography fontWeight={600}>User Plans</Typography>
      <ContainerWithLoader isLoading={loading} report={[null]}>
        <PlansTable />
      </ContainerWithLoader>
      <PaginationWithLimit
        page={pagination.page}
        setPageState={pagination.setPage}
        setLimit={pagination.setLimit}
        limit={pagination.limit}
        count={pagination.count}
      />
    </div>
  );
};

export default UserPlans;
